<template>
  <div>
    <splide
      v-if="computedItems.length"
      :slides="computedItems"
      :options="computedOptions"
      @splide:mounted="ready"
      ref="slide"
    >
      <splide-slide v-for="(item, index) in computedItems" :key="key(item[index])">
        <slot
          v-bind="{ items: item, item, index }"
        />
      </splide-slide>
    </splide>
  </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default {
  components: {
    Splide,
    SplideSlide,
  },

  props: {
    items: { type: Array, required: true },
    itemKey: { type: String, default: 'id' },
    options: { type: Object, default: () => ({}) }
  },

  data: () => ({
    defaultOptions: {
      group: false,
      gap: '1.5rem',
      fixedWidth: '18.75rem',
      pagination: false,
      trimSpace: 'move',
      padding: {
        left: 15,
        right: 15,
      }
    }
  }),

  methods: {
    ready () {
      this.$nextTick(() => {
        const ref = this.$refs.slide
        const screen = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        const container = ref.$el.querySelector('.splide__list').offsetWidth

        this.options.arrows = container > screen

        ref.splide.options = this.options
        ref.remount()
      })
    }
  },

  computed: {
    key () {
      return () => parseInt(100000 + Math.random() * 999999).toString()
    },
    computedItems () {
      return !this.computedOptions.group ? this.items : this.groupedItems
    },
    computedOptions () {
      return { ...this.defaultOptions, ...this.options }
    },
    groupedItems () {
      const transformedArray = []

      for (let i = 0; i < this.items.length; i += this.computedOptions.group) {
        const subarray = this.items.slice(i, i + this.computedOptions.group)
        transformedArray.push(subarray)
      }

      return transformedArray
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .splide {
    &__slide { padding-bottom: 10px }

    &__arrow {
      opacity: 1;
      background: linear-gradient(90deg, #FF7300 -3.33%, #FF5C00 100%);
      box-shadow: 0px 2.5rem4px rgba(0, 0, 0, 0.25), 5px 5px 30px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      transform: translate(0, -50%);
    
      top: 50%;
      width: 2.25rem;
      height: 2.25rem;
      border-radius: 100%;

      svg { fill: #fff; width: 50% }

      &--prev { left: 10px }
      &--next { right: 10px }

      &[disabled] { display: none }
    }
  }
</style>